/** Canonical customer routes (keep in sync with omind-backend-monorepo customer-routes.catalog.ts) */
/** Legacy seed paths → current Vue routes (keep in sync with omind-backend-monorepo customer-routes.catalog.ts) */
export const LEGACY_FEATURE_ROUTE_ALIASES = {
  '/360-mindset': '/external-evaluation',
  '/360mindset': '/external-evaluation',
  '/devTip': '/developmentTip',
  '/dashboard': '/my-results-dashboard',
  '/team-dashboard': '/team-results-dashboard',
};

/** Legacy feature catalogKey / type → navigation catalog keys */
export const LEGACY_CATALOG_KEY_ALIASES = {
  '360mindSet': 'externalEvaluation',
  ownResults: 'myResults',
};

export function normalizeCustomerRoute(route) {
  if (route == null || typeof route !== 'string') return undefined;
  const trimmed = route.trim();
  if (!trimmed) return undefined;
  return LEGACY_FEATURE_ROUTE_ALIASES[trimmed] ?? trimmed;
}

export const CUSTOMER_APP_ROUTES = [
  '/',
  '/kss-tracker',
  '/personal-goals',
  '/external-evaluation',
  '/workshops',
  '/personal-journey',
  '/reflexionGuideline',
  '/travel-buddy-history',
  '/coaching',
  '/coaching/profile',
  '/coaching/profiling',
  '/team-administration',
  '/management-dashboard',
  '/user-administration',
  '/knowledge-database',
  '/admin',
  '/my-results-dashboard',
  '/team-results-dashboard',
];

export const ACTIVITY_MENU_ROUTES = [
  '/travel-buddy-history',
  '/coaching',
  '/coaching/profile',
  '/coaching/profiling',
  '/personal-goals',
  '/personal-journey',
  '/reflexionGuideline',
  '/external-evaluation',
  '/kss-tracker',
  '/workshops',
  '/coaching',
];

const ROUTE_ICONS = {
  '/travel-buddy-history': 'pi pi-history',
  '/personal-goals': 'pi pi-flag',
  '/personal-journey': 'pi pi-map',
  '/reflexionGuideline': 'pi pi-bookmark',
  '/external-evaluation': 'pi pi-bullseye',
  '/kss-tracker': 'pi pi-comments',
  '/workshops': 'pi pi-users',
  '/coaching': 'pi pi-sparkles',
  '/coaching/profile': 'pi pi-user',
  '/coaching/profiling': 'pi pi-id-card',
};

export function iconForCustomerRoute(route) {
  return ROUTE_ICONS[route] || 'pi pi-circle';
}

export function isActivityMenuRoute(route) {
  return ACTIVITY_MENU_ROUTES.includes(route);
}

/** Route → catalogKey (keep in sync with omind-backend-monorepo navigation-catalog.ts). */
export const CATALOG_KEY_BY_CUSTOMER_ROUTE = {
  '/': 'home',
  '/travel-buddy-history': 'travelBuddyHistory',
  '/personal-goals': 'personalGoals',
  '/personal-journey': 'personalJourney',
  '/reflexionGuideline': 'reflexionGuideline',
  '/external-evaluation': 'externalEvaluation',
  '/kss-tracker': 'kssTracker',
  '/workshops': 'workshops',
  '/coaching': 'llmCoaching',
  '/coaching/profile': 'llmCoachingProfile',
  '/coaching/profiling': 'llmCoaching',
  '/my-results-dashboard': 'myResults',
  '/team-results-dashboard': 'teamResults',
  '/knowledge-database': 'knowledgeDatabase',
  '/management-dashboard': 'mngDashboard',
  '/user-administration': 'userAdministration',
  '/team-administration': 'teamAdministration',
  '/admin': 'admin',
};

const ROUTE_CATALOG_KEY_ENTRIES = Object.entries(CATALOG_KEY_BY_CUSTOMER_ROUTE)
  .sort((a, b) => b[0].length - a[0].length);

/** Canonical catalog key for a feature row (route wins, then legacy alias, then stored key). */
export function resolveCanonicalFeatureCatalogKey(feature) {
  const rawRoute = typeof feature?.route === 'string' ? feature.route.trim() : '';
  const normalizedRoute = rawRoute ? normalizeCustomerRoute(rawRoute) : undefined;
  const fromRoute = normalizedRoute ? catalogKeyForCustomerRoute(normalizedRoute) : null;
  if (fromRoute) return fromRoute;
  const rawKey = (feature?.catalogKey || '').trim();
  if (!rawKey) return '';
  return LEGACY_CATALOG_KEY_ALIASES[rawKey] || rawKey;
}

/** Resolve catalogKey for a customer app path (longest prefix match). */
export function catalogKeyForCustomerRoute(path) {
  if (!path || typeof path !== 'string') return null;
  const normalized = normalizeCustomerRoute(path.split('?')[0]) || path.split('?')[0];
  const matched = ROUTE_CATALOG_KEY_ENTRIES.find(([route]) => (
    normalized === route || (route !== '/' && normalized.startsWith(`${route}/`))
  ));
  return matched ? matched[1] : null;
}

/** Routes always allowed when authenticated (not subject to feature-nav allowlist). */
export const FEATURE_ACCESS_EXEMPT_ROUTES = [
  '/',
  '/gated-feature',
  '/edit-profile',
  '/admin',
];

/**
 * Customer menu routes that require a matching visible entry in `customerNavigation`.
 * Excludes home, admin, and utility routes.
 */
export function isFeatureManagedCustomerRoute(path) {
  if (!path || typeof path !== 'string') return false;
  const normalized = path.split('?')[0];
  if (FEATURE_ACCESS_EXEMPT_ROUTES.some((r) => normalized === r || normalized.startsWith(`${r}/`))) {
    return false;
  }
  return CUSTOMER_APP_ROUTES.some(
    (route) => normalized === route || normalized.startsWith(`${route}/`),
  );
}
